var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "container" }, [
    _c("div", { staticClass: "bg--white border-radius m-t-25 m-b-25 p-30" }, [
      _c("h1", [_vm._v("\n            Dashboard\n        ")]),
      _vm._v(" "),
      _vm._m(0),
      _vm._v(" "),
      _vm.canReadProducts
        ? _c("div", { staticClass: "row" }, [
            _c("div", { staticClass: "col-12" }, [
              _c(
                "div",
                {
                  staticClass:
                    "container-fluid d-flex flex-column flex-fill h-100",
                },
                [
                  _c("ak-data-table", {
                    attrs: {
                      bundle: "product",
                      definition: "dashboard-grid",
                      infiniteScroll: true,
                    },
                  }),
                ],
                1
              ),
            ]),
          ])
        : _vm._e(),
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "bg--white border-radius m-t-25 m-b-25 p-30" }, [
      _c("div", { staticClass: "row justify-content-center" }, [
        _c("div", { staticClass: "col-2" }, [
          _c("img", { attrs: { src: _vm.image } }),
        ]),
      ]),
    ]),
  ])
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-6" }, [
        _c("canvas", {
          staticClass: "order-chart",
          attrs: { "data-order-chart": "" },
        }),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-6" }, [
        _c("canvas", {
          staticClass: "products-chart",
          attrs: { "data-product-chart": "" },
        }),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }